<template>
  <div class="text-align-setting">
    <div class="horizontal layout center center-justified">
      <div
        class="flex text-align-item horizontal layout center left-aligned"
        @click="setTextAlign('left')"
        :class="{active: $store.state.slideActive.textAlign == 'left'}"
      >
        <i class="fas fa-align-left" />
      </div>
      <div
        class="flex text-align-item horizontal layout center center-justified"
        @click="setTextAlign('center')"
        :class="{active: $store.state.slideActive.textAlign == 'center'}"
      >
        <i class="fas fa-align-center" />
      </div>
      <div
        class="flex text-align-item horizontal layout center end-justified right-aligned"
        @click="setTextAlign('right')"
        :class="{active: $store.state.slideActive.textAlign == 'right'}"
      >
        <i class="fas fa-align-right" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Util from '@/util'
import Socket from '@/socket'
import SlideApi from '@/api/slide'
import EventBus from '@/eventBus'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },

  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    async setTextAlign(type) {
      try {
        this.setSyncLoadingAction(1)
        // to change CSS if can't use tinyMCE
        this.updateSlideActiveAction({
          textAlign: type,
        })
        // to change titleHTML if can use tinyMCE
        this._emitEventTextAlignmentToTextEditor(type)
        const params = {
          accessCode: this.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          textAlign: type,
          presenting: this.$store.getters.isPresenting,
        }
        await SlideApi.updateSlideById(this.slideActive.id, params)
        this.setSyncLoadingAction(2)
        Util.mixpanelTracking(
          'Slide',
          'Edit setting',
          'Presenter edit text align',
        )
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },
    _emitEventTextAlignmentToTextEditor(type) {
      let alignmentValue = 'JustifyLeft'
      if (type === 'center') {
        alignmentValue = 'JustifyCenter'
      } else if (type === 'right') {
        alignmentValue = 'JustifyRight'
      }
      EventBus.$emit('right-column: text-alignment', alignmentValue)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.text-align-setting {
    display: inline-block;
    margin: 0px 8px;
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    border-radius: 5px;

    .text-align-item {
        width: 31px;
        padding: 6px 8px;
        cursor: pointer;

        i {
            font-size: 13px;
        }

        &.active, &:hover {
            background-color: #fff;
            .fas {
                color: #666666;
            }
        }

        &.left-aligned {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        &.right-aligned {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
}
</style>
